<template>
	<!-- 执行标准 -->
	<div class="container_page">
		<!-- <div class="lang-radio-wrap">
			<a-radio-group v-model="filterData.lang" button-style="solid" @change="changeTabTop">
				<a-radio-button value="CH">中文版</a-radio-button>
				<a-radio-button value="EN">英文版</a-radio-button>
			</a-radio-group>
		</div> -->

		<a-form layout="inline">
			<a-form-item label="需求单号">
				<a-input v-model="filterData.inquiryNo"  placeholder="请输入需求单号"/>
			</a-form-item>
			<a-form-item label="称呼">
				<a-input v-model="filterData.userName"  placeholder="请输入称呼" />
			</a-form-item>
			<a-form-item label="时间范围">
				<a-range-picker v-model="filterData.timeDate" class="mr12" />
			</a-form-item>
			<a-form-item>
				<a-button class="mr12" type="primary" @click="toSearch(true)">查询</a-button>
				<a-button class="mr12" @click="toSearch(false)">重置</a-button>

				<!-- <a-button class="mr12" @click="scriptEdit">话术编辑</a-button>
				<a-button class="mr12">导入</a-button>
				<a-button @click="toAdd">新建标准</a-button> -->
			</a-form-item>
		</a-form>

		<div style="margin-top: 16px;margin-bottom: 16px;">
			<a-radio-group v-model="filterData.status" button-style="solid" @change="changeTab">
				<a-radio-button style="width: 150px;text-align: center;" v-for="item in tags" :key="item.tagId" :value="item.tagId">
					{{ item.tagName }}
					<span v-if="item.tagId == ''">{{ allNum }}</span>
					 <span v-else-if="item.tagId == 'PENDING'">{{ pendingNum }}</span>
					<span v-else-if="item.tagId == 'PROCESSING'">{{ processingNum }}</span>
					<span v-else-if="item.tagId == 'RESOLVED'">{{ resolvedNum }}</span>
				</a-radio-button>
			</a-radio-group>
		</div>
		<a-table :columns="columns" :data-source="tableData" :pagination="pageInfo" @change="changePage"
			:loading="loading">
			<template slot="petTypeRender" slot-scope="text, record">
				<!-- 正确写法 -->
				<div v-if="record.petType == 'DOG'">
					犬用
				</div>
				<div v-else-if="record.petType == 'CAT'">
					猫用
				</div>
				<div  v-else-if="record.petType == 'OTHER'">
					其他
				</div>
				<div v-else></div>
			</template>
			<template slot="statusRender" slot-scope="text, record">
				<a-tag color="#f50" v-if="record.status == 'PENDING'">
					待处理
				</a-tag>
				<a-tag color="#2db7f5" v-else-if="record.status == 'PROCESSING'">
					处理中
				</a-tag>
				<a-tag color="#87d068" v-else-if="record.status == 'RESOLVED'">
					已解决
				</a-tag>
				<a-tag v-else-if="record.status == 'CLOSED'">
					已关闭
				</a-tag>
				<a-tag v-else></a-tag>
			</template>
			<template slot="action" slot-scope="text, record">
				<div class="flex_center">
					<a-button type="link" @click="toEdit(record)">查看</a-button>
				</div>
			</template>

		</a-table>

		<!-- <a-modal :title="tipsModel.title" :visible="tipsModel.flag" @ok="tipsModel.onOk"
			@cancel="tipsModel.flag = false">
			<div>底部内容</div>
			<div><a-input v-model.number="tipsModel.bottomTitle" placeholder="标题" /></div>
			<div><a-input v-model.number="tipsModel.bottomContent" placeholder="内容" /></div>
		</a-modal> -->

	</div>
</template>

<script>
	import {
		ossUpload
	} from "../../utils/oss";
	import {
		getInquireListApi,
	} from "../../api/index";
	export default {
		name: "cardsList",
		data() {
			return {
				editorOption: {
					modules: {
						toolbar: [
							['bold', 'italic', 'underline', 'strike'],
							['color', 'background'], // 颜色功能在这里
							['clean']

						],
					},
					placeholder: "请输入内容",
					theme: 'snow'
				},
				columns: [
					{
						title: '序号',
						dataIndex: 'inquiryId',
						key: 'inquiryId',
					},
					{
						title: '需求单号',
						dataIndex: 'inquiryNo',
						key: 'inquiryNo',
					},
					{
						title: '用户称呼',
						dataIndex: 'userName',
						key: 'userName',
					},
					{
						title: '手机号码',
						dataIndex: 'userPhone',
						key: 'userPhone',
					},
					{
						title: '公司名称',
						dataIndex: 'companyName',
						key: 'companyName',
					},
					{
						title: '目标宠物类别',
						dataIndex: 'petType',
						key: 'petType',
						scopedSlots: {
							customRender: 'petTypeRender'
						},
					},
					{
						title: '其他需求说明',
						dataIndex: 'otherRequirements',
						key: 'otherRequirements',
					},
					{
						title: '需求提交时间',
						dataIndex: 'createTime',
						key: 'createTime',
					},
					{
						title: '处理状态',
						dataIndex: 'status',
						key: 'status',
						scopedSlots: {
							customRender: 'statusRender'
						},
					},
					{
						title: '操作',
						key: 'action',
						scopedSlots: {
							customRender: 'action'
						},
					}
				],
				tableData: [],
				pageInfo: {
					pageSize: 20,
					current: 1,
					total: 0,
					showTotal: (total, range) => {
						return `合计 ${total} 条记录`;
					},
				},
				loading: false,
				imgModel: {
					flag: false,
					url: "",
				},
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				filterData: {
					inquiryNo: "",
					userName: "",
					status: '',
					timeDate: [],
				},
				tagsTop: [
					{tagId:'',tagName:"全部"},
					{tagId:'PENDING',tagName:"待处理"},
					{tagId:'PROCESSING',tagName:"处理中"},
					{tagId:'RESOLVED',tagName:"已处理"}
				],
				   // 标签统计数量
				allNum: 0,
				pendingNum: 0,
				processingNum: 0,
				resolvedNum: 0,
				tags: [
					  {tagId:'',tagName:"全部", numKey: 'allNum'},
						{tagId:'PENDING',tagName:"待处理", numKey: 'pendingNum'},
						{tagId:'PROCESSING',tagName:"处理中", numKey: 'processingNum'},
						{tagId:'RESOLVED',tagName:"已处理", numKey: 'resolvedNum'}
				],
			};
		},
		created() {},
		activated() {},
		mounted() {
			const storedQuery = localStorage.getItem('oemConsult_searchQuery');
			if (storedQuery) {
				this.filterData = JSON.parse(storedQuery);
			} else {}
			this.getData(1)
		},
		beforeRouteLeave(to, from, next) {
			localStorage.setItem('oemConsult_searchQuery', JSON.stringify(this.filterData));
			next();
		},
		methods: {
			changeTabTop() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},
			changeTab() {
				this.pageInfo.current = 1;
				this.getData(1); // 重新拉取列表接口，把tagTypeCategory传给后端筛选
			},
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},

			changePage(page) {
				this.pageInfo.current = page.current;
				this.getData(this.pageInfo.current);
			},
			toSearch(flag) {
				if (flag) {
					this.getData(1);
				} else {
					let status = this.filterData.status

					this.filterData = {
						inquiryNo: "",
						userName: "",
						status: status,
						timeDate: [],
					};
					this.getData(1);
				}
			},
			getData(page = 1) {
				this.pageInfo.current = page;
				if (this.loading) {
					return;
				}
				this.loading = true;
				getInquireListApi({
						pageNo: this.pageInfo.current,
						pageSize: this.pageInfo.pageSize,
						inquiryNo: this.filterData.inquiryNo,
						userName: this.filterData.userName,
						status: this.filterData.status,
						startDate:
						this.filterData.timeDate.length === 2
							? this.$moment(this.filterData.timeDate[0]).format(
								"YYYY-MM-DD"
							)
							: null,
						endDate:
						this.filterData.timeDate.length === 2
							? this.$moment(this.filterData.timeDate[1]).format(
								"YYYY-MM-DD"
							)
							: null,
					})
					.then((res) => {
						if (res.resultStatus) {
							this.tableData = res.resultData.dataList || [];
							this.pageInfo.total = res.resultData.totalNum || 0;

							  // 后端返回的统计字段赋值
							this.allNum = res.resultData.allNum|| 0;
							this.pendingNum = res.resultData.pendingNum|| 0;
							this.processingNum = res.resultData.processingNum|| 0;
							this.resolvedNum = res.resultData.resolved|| 0;

						} else {
							this.tableData = [];
							this.pageInfo.total = 0;
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			toAdd() {
			},
			toEdit(data) {
			this.$router.push({
					name: 'OEMCONSULTDETAIL',
					params: {
						id: data.inquiryId
					}
				});
			}
		},
	};
</script>

<style lang="less">
	.container_page {
		padding: 20px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}

	.size_item {
		height: 50px;
		/* 改为固定高度，不要 min-height */
		background: #f7f7f7;
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 8px 0;
		/* 间距改小，更美观 */
		cursor: move;
		padding: 0 10px;

		.left {
			flex: 1;
			padding-left: 10px;
		}

		.right {
			width: 50px;
			text-align: center;
		}
	}

	.lang-radio-wrap {
		display: flex;
		justify-content: center;
		margin-bottom: 16px;
	}
</style>
